export const envConfigMap = {
  LOCAL: {
    // gwsPath: "https://api-cn-sit.midea.com/oversea-collection",
    gwsPath: "https://uat-api-website.midea.com/oversea-collection",
    // gwsPath: "",
    aemPath: "",
    scrmPathMap: {
      // hk: null,
      // us: null,
      // hk: 'https://ibs-dev.midea.com',
      // us: 'https://ibs-dev.midea.com',
      hk: "https://iscrm-uat-hk.midea.com",
      us: "https://iscrm-sit.midea.com",
      eu: "https://iscrm-uat-eu.midea.com",
    },
    idcpPath: "https://idcp-ibs-uat.midea.com",  // faq组件调用idcp接口
    idcpAppKey: "1r4qo26KGmzuev63",
    idcpSecret: "6uIlJRqwwcZ2iYshTKO3J1uF02ilpamL",
    // 德国4a登陆mc接口
    mcPathMap: {
      hk: "",
      us: "",
      eu: "https://mideaclub-uat-eu.midea.com/api/mc-usercenter",
    },
  },
  DEV: {
    gwsPath: "https://api-cn-sit.midea.com/oversea-collection",
    scrmPathMap: {
      hk: 'https://ibs-dev.midea.com',
      us: 'https://ibs-dev.midea.com',
      eu: 'https://ibs-dev.midea.com',
    },
    // 德国4a登陆mc接口
    mcPathMap: {
      hk: "",
      us: "",
      eu: "https://mideaclub-uat-eu.midea.com/api/mc-usercenter",
    },
  },
  SIT: {
    gwsPath: "https://api-cn-sit.midea.com/oversea-collection",
    scrmPathMap: {
      hk: "https://iscrm-sit.midea.com",
      us: "https://iscrm-sit.midea.com",
      eu: "https://iscrm-sit.midea.com",
    },
    // idcpPath: "https://idcpsit.midea.com/contentCenter-sit",
    idcpPath: "https://idcp-ibs-uat.midea.com",
    idcpAppKey: "1r4qo26KGmzuev63",
    idcpSecret: "6uIlJRqwwcZ2iYshTKO3J1uF02ilpamL",
    // 德国4a登陆mc接口
    mcPathMap: {
      hk: "",
      us: "",
      eu: "https://mideaclub-uat-eu.midea.com/api/mc-usercenter",
    },
  },
  UAT: {
    gwsPath: "https://uat-api-website.midea.com/oversea-collection",
    scrmPathMap: {
      hk: "https://iscrm-uat-hk.midea.com",
      us: "https://iscrm-uat-us.midea.com",
      eu: "https://iscrm-uat-eu.midea.com",
    },
    idcpPath: "https://idcp-ibs-uat.midea.com",
    idcpAppKey: "1r4qo26KGmzuev63",
    idcpSecret: "6uIlJRqwwcZ2iYshTKO3J1uF02ilpamL",
    // 德国4a登陆mc接口
    mcPathMap: {
      hk: "",
      us: "",
      eu: "https://mideaclub-uat-eu.midea.com/api/mc-usercenter",
    },
  },
  PROD: {
    gwsPath: "https://api-website.midea.com/oversea-collection",
    scrmPathMap: {
      hk: "https://iscrm-hk.midea.com",
      us: "https://iscrm-us.midea.com",
      eu: "https://iscrm-eu.midea.com",
    },
    idcpPath: "https://idcp-ibs.midea.com",
    idcpAppKey: "YV0sbBohjIM4wuOS",
    idcpSecret: "BniaHeTuZ4gICOoZntFM1rnHwLDilPQG",
    // 德国4a登陆mc接口
    mcPathMap: {
      hk: "",
      us: "",
      eu: "https://mideaclub-eu.midea.com/api/mc-usercenter",
    },
  },
};
// scrm需要访问us数据中心的站点，其他站点访问hk数据中心
export const sitesForScrmUsDataCenter = ["ca"];

// scrm需要访问eu数据中心的站点
export const sitesForScrmEuDataCenter = ["global","uk"];
